import api from "./api";

export const getWarehousesBy = async (warehousesId: string | undefined) => {
  const response = await api.get(`/warehouses/${warehousesId}`);
  return response.data.name; // return only the name of the item
};

export const getWarehousesInventories = async (body: {
  warehouseid: string | number | undefined;
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/inventories/warehouse/${body.warehouseid}?limit=${
    body.limit
  }&q=${body.q.toString()}`;
  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }
  return await api.get(url);
};

